import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Consulting(props) {
    return (
        <section className="tekgrip_section  p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="Application">
                            <h2>Hire Node.Js Developers For Scalable Applications</h2>
                        </div>
                        {/*<div*/}
                        {/*    className="main_para"><p>TekRevol's SAP consulting can help you customize SAP*/}
                        {/*    functionalities and match them with your business requirements and future scalability goals.*/}
                        {/*    You can add or accelerate features, combine functionalities, and put features into action*/}
                        {/*    according to your organizational structure and goals with compatible coding solutions.</p>*/}
                        {/*</div>*/}
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Accelerated DevOps</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Strong Portfolio</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Agile Approach</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="3">Tech Stack</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>DevOps is already about faster product delivery with the collaboration of development operations. Our Node.js developers, with their dedicated development environments, are a dynamic duo that further enhances the technical delivery speeds of our DevOps efforts.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>We have a robust programming portfolio in Node.js with multiple successes in competitive areas like social apps, waste management systems, traffic optimization architectures, cloud infrastructures, and enterprise-grade SaaS. That’s because of the capabilities of our Node.js developers, along with product strategists, business analysts, and software developers.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>Our agile development approach is another reason our portfolios hit the market big. We emphasize end-user experience, build and test in real-time, and balance consumer priorities and product qualities. These practices help us report transparent, improve project visibility and reduce risk.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="3">
                                            <p>While Node.js is a popular backend tool at TekRevol, our developers have expertise and experience utilizing the most emerging technology stacks. We have specialized developers in Blockchain, Mixed Reality, digital commerce, AI and Machine Learning, Bluetooth low energy, and the Internet of Things.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Accelerated DevOps</Accordion.Header>
                                    <Accordion.Body>
                                        <p>DevOps is already about faster product delivery with the collaboration of development operations. Our Node.js developers, with their dedicated development environments, are a dynamic duo that further enhances the technical delivery speeds of our DevOps efforts.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Strong Portfolio</Accordion.Header>
                                    <Accordion.Body>
                                        <p>We have a robust programming portfolio in Node.js with multiple successes in competitive areas like social apps, waste management systems, traffic optimization architectures, cloud infrastructures, and enterprise-grade SaaS. That’s because of the capabilities of our Node.js developers, along with product strategists, business analysts, and software developers.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Agile Approach</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our agile development approach is another reason our portfolios hit the market big. We emphasize end-user experience, build and test in real-time, and balance consumer priorities and product qualities. These practices help us report transparent, improve project visibility and reduce risk.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Tech Stack</Accordion.Header>
                                    <Accordion.Body>
                                        <p>While Node.js is a popular backend tool at TekRevol, our developers have expertise and experience utilizing the most emerging technology stacks. We have specialized developers in Blockchain, Mixed Reality, digital commerce, AI and Machine Learning, Bluetooth low energy, and the Internet of Things.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Consulting;